import React, { useEffect, useState } from 'react';
import { getUsuarioActual } from '../apiAuth';
import { useFiltroUsuarios, setFiltroUsuarios } from '../filtroUsuarios';

// Filtro "Usuario(s)" del Administrador Plus: uno, varios o todos los usuarios
// que tiene asignados (más él mismo). Convive con los filtros propios de cada
// módulo; la selección es global (ver filtroUsuarios.js) y el backend la
// aplica vía header. Para cualquier otro rol no se renderiza.

let opcionesCache = null; // una sola carga por sesión de página

export default function FiltroUsuarios({ ancho = 240, contenedorStyle, etiqueta = true }) {
  const usuarioActual = getUsuarioActual();
  const esAdminPlus = usuarioActual?.rol === 'administrador_plus';
  const seleccion = useFiltroUsuarios();
  const [opciones, setOpciones] = useState(opcionesCache || []);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!esAdminPlus || opcionesCache) return;
    fetch('/api/mis-usuarios-visibles')
      .then(r => r.json())
      .then(d => {
        if (!Array.isArray(d)) return;
        opcionesCache = d.map(u => ({
          v: u.id,
          l: (u.nombre_completo || u.usuario) + (u.id === usuarioActual.id ? ' (yo)' : ''),
        }));
        setOpciones(opcionesCache);
      })
      .catch(() => {});
  }, [esAdminPlus, usuarioActual?.id]);

  if (!esAdminPlus) return null;

  const toggle = (v) => {
    const nueva = seleccion.includes(v) ? seleccion.filter(x => x !== v) : [...seleccion, v];
    // Marcar a todos equivale a "Todos"; desmarcar el último también.
    setFiltroUsuarios(nueva.length === opciones.length ? [] : nueva);
  };

  const resumen = seleccion.length === 0
    ? 'Todos'
    : seleccion.length === 1
      ? (opciones.find(o => o.v === seleccion[0])?.l ?? String(seleccion[0]))
      : `${seleccion.length} seleccionados`;

  return (
    <div style={{ width: ancho, ...contenedorStyle }} data-filtro-usuarios>
      {etiqueta && <label style={st.label}>Usuario(s)</label>}
      <div style={{ position: 'relative' }}>
        <button type="button" style={{ ...st.btn, ...(seleccion.length ? st.btnActivo : {}) }} onClick={() => setOpen(o => !o)}>
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>👥 {resumen}</span>
          <span style={{ color: '#6b7280' }}>▾</span>
        </button>
        {open && (
          <>
            <div onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, zIndex: 15 }} />
            <div style={st.menu}>
              <label style={st.item}>
                <input type="checkbox" checked={seleccion.length === 0} onChange={() => setFiltroUsuarios([])} />
                <strong>Todos</strong>
              </label>
              <div style={st.divider} />
              {opciones.map(o => (
                <label key={o.v} style={st.item}>
                  <input type="checkbox" checked={seleccion.includes(o.v)} onChange={() => toggle(o.v)} />
                  {o.l}
                </label>
              ))}
              {opciones.length === 1 && (
                <div style={{ padding: '6px 8px', fontSize: 12, color: '#9ca3af', whiteSpace: 'normal' }}>
                  Aún no tiene usuarios asignados.
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

const st = {
  label: { display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 4 },
  btn: { padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14, backgroundColor: 'white', cursor: 'pointer', textAlign: 'left', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, width: '100%', boxSizing: 'border-box' },
  btnActivo: { borderColor: '#2563eb', backgroundColor: '#eff6ff' },
  menu: { position: 'absolute', top: '100%', left: 0, marginTop: 4, backgroundColor: 'white', border: '1px solid #d1d5db', borderRadius: 6, boxShadow: '0 4px 12px rgba(0,0,0,0.15)', zIndex: 20, maxHeight: 320, overflowY: 'auto', padding: 6, minWidth: 240 },
  item: { display: 'flex', alignItems: 'center', gap: 8, padding: '6px 8px', fontSize: 13, cursor: 'pointer', borderRadius: 4, whiteSpace: 'nowrap', fontWeight: 'normal' },
  divider: { borderTop: '1px solid #e5e7eb', margin: '4px 0' },
};
